<template>
  <!-- A caixa INTEIRA é o alvo, e não só o cabeçalho: aqui não há sub-alvo nenhum — o
       domínio se edita como um todo, e clicar numa opção levaria ao mesmo lugar. É o que
       a diferencia da caixa de classe, cuja raiz não tem clique porque cada linha dela
       leva a um lugar diferente.

       role/tabindex e não v-btn, como na caixa de classe: são blocos de altura fixa, e o
       v-btn imporia altura, centralização e caixa-alta ao conteúdo. -->
  <div class="class-box is-domain-box" :style="style"
       role="button" tabindex="0"
       :title="$tt('domain-design-named', {domain: domain.name})"
       @click="$emit('open')"
       @keydown.enter="$emit('open')" @keydown.space.prevent="$emit('open')">
    <div class="class-box-header is-domain">
      <v-icon size="small" start color="white">mdi-format-list-bulleted</v-icon>
      <span class="class-box-title">{{ domain.name }}</span>
    </div>

    <!-- Um compartimento, sem faixa de título: o nome já é o cabeçalho. A bolinha colorida
         é a mesma das situações — a cor guardada na opção é um nome-base do Vuetify, como
         a que o StateColorizer deriva, então o v-icon recebe as duas do mesmo jeito.

         Sem title por linha: ele venceria o da caixa justamente onde o ponteiro passa
         mais tempo, e a dica de que dá para clicar desapareceria. -->
    <div class="class-box-compartment">
      <div v-for="option of domain.options" :key="option.id" class="class-box-row">
        <span class="class-box-markers">
          <v-icon size="x-small" :color="option.color">mdi-circle-medium</v-icon>
        </span>
        <span class="class-box-name">{{ option.name }}</span>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import Domain from '@/types/Domain'
import {boxProperties} from '@/utils/classDiagram'

/**
 * A caixa de um domínio no diagrama: cabeçalho com o nome e as opções com a cor de cada
 * uma.
 *
 * Mesma notação da caixa de classe — mesma largura, mesma altura de linha, mesma folha de
 * estilo — porque é ali que ela precisa ser lida junto. O que a distingue é o cabeçalho
 * laranja: um domínio não é coleção, não tem chave nem instância, e vive no ambiente.
 *
 * Só aparece quando algum atributo o usa; quem decide isso é o classDiagramModel, que
 * monta a caixa e a seta que chega nela na mesma passada.
 */
@Component({emits: ['open'], name: 'ontos-domain-box'})
class DomainBox extends Vue {
  @Prop({type: Object, required: true}) readonly domain!: Domain

  //exposto ao template: função de módulo não é enxergada de lá
  style = boxProperties()
}

export default toNative(DomainBox)
</script>
<!-- O desenho é o mesmo da caixa de classe: uma folha só, dois componentes. -->
<style scoped src="./box.css"></style>
